'use client'

import {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useState,
} from 'react'

export const createContextWithProvider = <T,>(name: string) => {
	const context = createContext(null as unknown as T)

	const Provider = ({ children, value }: { children: ReactNode; value: T }) => (
		<context.Provider value={value}>{children}</context.Provider>
	)

	Provider.displayName = `${name}Provider`

	return [context, Provider] as const
}

export const createStateContext = <T,>({
	name,
	defaultValue,
}: {
	name: string
	defaultValue?: T
}) => {
	const [context, Provider] =
		createContextWithProvider<[T, Dispatch<SetStateAction<T>>]>(name)

	const StatefulProvider = ({
		initialValue: initialValue,
		children,
	}: {
		initialValue?: T
		children: ReactNode
	}) => {
		const [value, setValue] = useState<T>(initialValue || (defaultValue as T))

		return <Provider value={[value, setValue]}>{children}</Provider>
	}

	return [context, StatefulProvider] as const
}
